<template>
  <div class="animated fadeIn">
    <b-card>
      <template #header>
        <strong>Instellingen</strong>
        <small class="text-muted ml-2">
          Deze voorkeuren worden lokaal op dit apparaat / in deze browser opgeslagen.
        </small>
      </template>

      <b-form>
        <h5>Dashboard</h5>
        <b-form-group
          description="Schakel in om de oude dashboard-weergave te tonen in plaats van het nieuwe dashboard met jaarselectie."
        >
          <b-form-checkbox
            v-model="useOldDashboard"
            switch
            @change="onChangeUseOldDashboard"
          >
            Gebruik het oude dashboard overzicht
          </b-form-checkbox>
        </b-form-group>

        <hr>

        <h5>Menu</h5>
        <b-form-group
          description="Schakel in om de nieuwe menu-indeling in de zijbalk te gebruiken. Uitschakelen brengt de oude menu-indeling terug."
        >
          <b-form-checkbox
            v-model="useNewMenu"
            switch
            @change="onChangeUseNewMenu"
          >
            Gebruik de nieuwe menu-indeling
          </b-form-checkbox>
        </b-form-group>

        <hr>

        <div>
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="resetSettings"
          >
            Standaardinstellingen herstellen
          </b-button>
        </div>

        <b-alert
          v-if="savedMessage"
          show
          variant="success"
          class="mt-3 mb-0"
          dismissible
          @dismissed="savedMessage = ''"
        >
          {{ savedMessage }}
        </b-alert>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  getUserSetting,
  setUserSetting,
  resetUserSettings
} from '@/utils/userSettings';

export default {
  name: 'UserSettings',
  data() {
    return {
      useOldDashboard: getUserSetting('useOldDashboard', false),
      useNewMenu: localStorage.getItem('useNewMenu') === 'true',
      savedMessage: ''
    };
  },
  mounted() {
    window.addEventListener('menu-layout-changed', this.onMenuLayoutChanged);
  },
  beforeDestroy() {
    window.removeEventListener('menu-layout-changed', this.onMenuLayoutChanged);
  },
  methods: {
    onChangeUseOldDashboard(val) {
      setUserSetting('useOldDashboard', val);
      this.flash('Instelling opgeslagen.');
    },
    onChangeUseNewMenu(val) {
      localStorage.setItem('useNewMenu', val ? 'true' : 'false');
      window.dispatchEvent(new CustomEvent('menu-layout-changed', { detail: { useNewMenu: val } }));
      this.flash('Instelling opgeslagen.');
    },
    onMenuLayoutChanged(e) {
      const newValue = !!(e && e.detail && e.detail.useNewMenu);
      if (this.useNewMenu !== newValue) {
        this.useNewMenu = newValue;
      }
    },
    resetSettings() {
      resetUserSettings();
      this.useOldDashboard = false;
      this.useNewMenu = false;
      localStorage.setItem('useNewMenu', 'false');
      window.dispatchEvent(new CustomEvent('menu-layout-changed', { detail: { useNewMenu: false } }));
      this.flash('Instellingen hersteld naar standaard.');
    },
    flash(msg) {
      this.savedMessage = msg;
      setTimeout(() => {
        if (this.savedMessage === msg) this.savedMessage = '';
      }, 2500);
    }
  }
};
</script>
